export const REQUESTS_NOTICE =
  "Все неизрасходованные запросы не переносятся по истечении действия тарифа";
